const pageHeaders = {
  USER: {
    main: "社内電話帳一覧",
    edit: "社内電話帳情報編集",
    create: "社内電話帳情報参照・編集",
    add: "社内電話帳新規登録",
    photoUpload: "顔写真アップロード",
    changePassword: "パスワード変更",
    myPage: "マイページ",
    personalInfo: "個人情報",
    passwordChange: "管理者パスワード変更",
    csvUpload: "社内電話帳一括登録",
    csvUploadTitle: "社内電話帳一括登録",
  },
  TENANT: {
    main: "企業一覧",
    manage: "企業情報管理",
    create: "企業情報作成",
    add: "企業新規追加",
    edit: "基本情報設定",
    csvUpload: "企業一括登録",
    csvUploadTitle: "企業一括登録",
  },
  NOTIFICATION: {
    main: "お知らせ一覧",
    create: "お知らせ追加",
    add: "お知らせ追加",
    edit: "お知らせ編集",
    view: "お知らせ登録・編集",
  },
  KAKELY: {
    mainExternal: "社外電話帳一覧",
    mainInternal: "社内電話帳一覧",
    departmentView: "部署一覧表示設定",
    departmentSettings: "部署一覧表示設定",
    departmentCreate: "部署一覧表示設定",
    departmentMain: "部署一覧",
    departmentEdit: "部署情報更新",
    departmentAdd: "新部署追加",
    departmentMasterAdd: "最上位階層の追加",
    phonebookEdit: "電話帳登録・編集画面",
    phonebookAdd: "電話帳登録・編集画面",
    phonebookView: "電話帳情報",
    csvUploadExternal: "社外電話帳一括登録",
    csvUploadTitleExternal: "社外電話帳一括登録",
    csvUploadDepartmentGroup: "部署一括登録",
    csvUploadInternal: "社内電話帳一括登録",
    csvUploadTitleInternal: "社内電話帳一括登録",
  },
  YOBELY: {
    main: "一斉発信グループ一覧",
    groupView: "一斉発信グループ一覧・登録",
    groupAdd: "一斉発信グループ登録",
    groupMasterAdd: "最上位階層の追加",
    groupEdit: "一斉発信グループ編集",
  },
  HOME: {
    main: "管理者からのお知らせ",
  },
};

export default pageHeaders;
